// extracted by mini-css-extract-plugin
export default {"input":"_6AjCDlv7lNBjEzNk1z1qc1"};